/* tslint:disable */
import {
  Audio,
  Image,
  QuickArt,
  Video,
  KanvasUser,
  Feed,
  Screen
} from '../index';

declare var Object: any;
export interface LibraryInterface {
  "id": string;
  "kanvasUserId_privateLibrary"?: string;
  "kanvasUserId_publicLibrary"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  audios?: Audio[];
  images?: Image[];
  quickarts?: QuickArt[];
  videos?: Video[];
  kanvasUserPrivateLibrary?: KanvasUser;
  kanvasUserPublicLibrary?: KanvasUser;
  feeds?: Feed[];
  screens?: Screen[];
}

export class Library implements LibraryInterface {
  "id": string;
  "kanvasUserId_privateLibrary": string;
  "kanvasUserId_publicLibrary": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  audios: Audio[];
  images: Image[];
  quickarts: QuickArt[];
  videos: Video[];
  kanvasUserPrivateLibrary: KanvasUser;
  kanvasUserPublicLibrary: KanvasUser;
  feeds: Feed[];
  screens: Screen[];
  constructor(data?: LibraryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Library`.
   */
  public static getModelName() {
    return "Library";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Library for dynamic purposes.
  **/
  public static factory(data: LibraryInterface): Library{
    return new Library(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Library',
      plural: 'Libraries',
      path: 'Libraries',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "kanvasUserId_privateLibrary": {
          name: 'kanvasUserId_privateLibrary',
          type: 'string'
        },
        "kanvasUserId_publicLibrary": {
          name: 'kanvasUserId_publicLibrary',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        audios: {
          name: 'audios',
          type: 'Audio[]',
          model: 'Audio',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
        images: {
          name: 'images',
          type: 'Image[]',
          model: 'Image',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
        quickarts: {
          name: 'quickarts',
          type: 'QuickArt[]',
          model: 'QuickArt',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
        videos: {
          name: 'videos',
          type: 'Video[]',
          model: 'Video',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
        kanvasUserPrivateLibrary: {
          name: 'kanvasUserPrivateLibrary',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId_privateLibrary',
          keyTo: 'id'
        },
        kanvasUserPublicLibrary: {
          name: 'kanvasUserPublicLibrary',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId_publicLibrary',
          keyTo: 'id'
        },
        feeds: {
          name: 'feeds',
          type: 'Feed[]',
          model: 'Feed',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'libraryId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Library.ts